import { replaceWhiteLabelTitle } from 'library-@/utils/replaceWhiteLabelTitle';

export default function setTitle({ locale = 'en', isWhiteLabel = false }) {
    const title = {
        cn: '专利详情页 - 智慧芽',
        en: 'Patent View - PatSnap',
        jp: '特許詳細 - PatSnap',
        de: 'Patent-Angaben - PatSnap',
        tw: '專利詳情頁 - 智慧芽'
    };
    document.title = replaceWhiteLabelTitle({ title: title[locale] || title['en'], isWhiteLabel });
}
